module.exports = __webpack_public_path__ + "static/img/天坛.2dbf565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/天坛.png
// module id = hsNz
// module chunks = 1